import {AfterViewInit, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {CartService} from "../../../../service/cart";
import {ApiService} from "../../../../service/api";

@Component({
    selector: 'pickup-dialog',
    templateUrl: './pickup.component.html',
    styleUrls: ['./pickup.component.css']
})
export class PickupDialog {

    public total: any;
    public payment: any;
    public purchase: any;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public cart: CartService, public api: ApiService,
                public dialogRef: MatDialogRef<PickupDialog>) {
        this.payment = data.payment;
        this.total = data.total;
        this.purchase = data.purchase;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/checkout/dialog/pickup/pickup.component.ts